<template functional>
    <div class="loader-wrapper">
        <picture>
          <img v-if="props.brandName === 'Travelsphere'" src="/Static/images/gif/ts-checkout-loader.gif" alt="CheckoutLoader" loading="lazy">
          <img v-else src="/Static/images/gif/checkout-loader-j.gif" alt="CheckoutLoader" loading="lazy">
        </picture>
        <p>We are building your holiday</p>
    </div>
</template>

<script>
export default {
  props: ['brandName']
};
</script>